import AppPagePoweredBy from "./AppPagePoweredBy";

import "./AppPagePoweredBy.scss";

export { AppPagePoweredBy };
